export default {
    computed: {
        // getters from store
        cartId() {
            return this.$store.getters.cartId;
        },
        cartItems() {
            return this.$store.getters.cartItems();
        },
        cartPricing() {
            return this.$store.getters.cartPricing();
        },
        cartExpiredDate() {
            return this.$store.getters.cartExpiredDate();
        },
        cartEarlyRenewal() {
            return this.$store.getters.cartEarlyRenewal();
        },
        cartEarlyRenewalDiscount() {
            return this.$store.state.cart.earlyRenewalDiscount;
        },
        cartContactAdded() {
            return this.$store.state.cart.contactAdded;
        },
        cartContactMailAddress() {
            return this.$store.state.cart.contactMailAddress;
        },
        cartContactName() {
            return this.$store.state.cart.contactName;
        },
        cartContactPhone() {
            return this.$store.state.cart.contactPhone;
        },
        cartPeriodStartDate() {
            return this.$store.getters.cartPeriodStartDate();
        },
        cartPeriodStopDate() {
            return this.$store.getters.cartPeriodStopDate();
        },
        cartPeriodStartDateObj() {
            return moment(this.cartPeriodStartDate || null);
        },
        cartPeriodStopDateObj() {
            return moment(this.cartPeriodStopDate || null);
        },
        cartExpiredDateObj() {
            return moment(this.cartExpiredDate || null);
        },
        cartContext() {
            return this.$store.getters.cartContext();
        },
        cartSource() {
            return this.$store.getters.cartSource();
        },
        cartPaymentMethod() {
            return this.$store.getters.cartPaymentMethod();
        },
        cartPaymentFacility() {
            return this.$store.getters.cartPaymentFacility();
        },
        cartIsCancelable() {
            return this.$store.getters.cartIsCancelable();
        },
        // getters from store for saved card
        savedCartItems() {
            return this.$store.getters.cartItems(true);
        },
        savedCartPricing() {
            return this.$store.getters.cartPricing(true);
        },
        savedCartExpiredDate() {
            return this.$store.getters.cartExpiredDate(true);
        },
        savedCartPeriodStartDate() {
            return this.$store.getters.cartPeriodStartDate(true);
        },
        savedCartPeriodStopDate() {
            return this.$store.getters.cartPeriodStopDate(true);
        },
        savedCartSource() {
            return this.$store.getters.cartSource(true);
        },
        savedCartPaymentMethod() {
            return this.$store.getters.cartPaymentMethod(true);
        },
        savedCartPaymentFacility() {
            return this.$store.getters.cartPaymentFacility(true);
        },
        savedCartTotal() {
            return this.$store.getters.cartSavedTotal;
        },
        savedCartStatus() {
            return this.$store.getters.cartSavedStatus;
        },
        // getters from store for paymentIntent
        cartPaymentIntent() {
            return this.$store.getters.cartPaymentIntent;
        },
        cartPaymentIntentTotal() {
            return this.$store.getters.cartPaymentIntentTotal;
        },

        // computed
        isCartLoaded() {
            return this.cartId !== null;
        },

        cartIsExpired() {
            return this.$store.getters.cartIsExpired;
        },
        cartIsCancelable() {
            return this.$store.getters.cartIsCancelable;
        },

        deadlines() {
            const date = this.cartEarlyRenewal ? moment() : moment(this.cartPeriodStartDate);
            let discount = this.centsToCurrency(this.cartEarlyRenewalDiscount);
            const deadlines = [];
            for (let month = 0; month < 12; month++) {
                let amount = this.currentPricingTotal.totalDiscounted;
                date.add(1, 'M');

                if (discount > amount) {
                    discount -= amount;
                    amount = 0;
                } else {
                    amount -= discount;
                    discount = 0;
                }

                if (amount !== this.currentPricingTotal.totalDiscounted) {
                    deadlines.push({
                        key: month,
                        date: date.clone(),
                        amount: this.round(amount + this.applyTax(amount), 2),
                    });
                }
            }
            return deadlines;
        },
        deadlineUnchanged() {
            let discount = this.centsToCurrency(this.cartEarlyRenewalDiscount);
            let deadlinesUnchanges = 0;
            for (let month = 0; month < 12; month++) {
                let amount = this.currentPricingTotal.totalDiscounted;

                if (discount > amount) {
                    discount -= amount;
                    amount = 0;
                } else {
                    amount -= discount;
                    discount = 0;
                }

                if (amount === this.currentPricingTotal.totalDiscounted) {
                    deadlinesUnchanges++;
                }
            }

            return deadlinesUnchanges;
        },
        isPaymentFacilityEnabled() {
            return (
                !this.isCartContext('upsale') &&
                !this.isCurrentPricingMonthly &&
                this.cartPaymentFacility > 1 &&
                this.cartPaymentFacility < 12
            );
        },
        cartFacilityAmounts() {
            return this.buildFacilityAmounts(
                this.cartTotal.yearly.totalTaxIncluded,
                this.cartPaymentFacility,
            );
        },
        cartFirstAmountFacility() {
            return this.cartFacilityAmounts.firstAmount;
        },
        cartNextAmountFacility() {
            return this.cartFacilityAmounts.nextAmount;
        },
        quotasByCountryCode() {
            return this.getQuotasByCountryCode(this.billingAddress.country);
        },
        cartNbFacilities() {
            if (this.isCurrentPricingMonthly || this.isCartContext('upsale')) {
                return 1;
            }

            return this.isCustomPaymentFacilityEnabled
                ? this.cartNbCustomFacilities
                : this.cartPaymentFacility;
        },
        isCustomPaymentFacilityEnabled() {
            return (
                !this.isCartContext('upsale') &&
                !this.isCurrentPricingMonthly &&
                this.cartPaymentFacility > 10000
            );
        },
        cartCustomFacilitiesAmount() {
            return this.buildCustomFacilityAmounts(
                this.cartTotal.yearly.totalTaxIncluded,
                this.cartPaymentFacility,
            );
        },
        cartNbFirstCustomFacilities() {
            return this.cartCustomFacilitiesAmount.nbFirstFacilities;
        },
        cartNbCustomFacilities() {
            return this.cartCustomFacilitiesAmount.nbFirstFacilities + 1;
        },
        cartFirstAmountCustomFacility() {
            return this.cartCustomFacilitiesAmount.firstAmount;
        },
        cartLastAmountCustomFacility() {
            return this.cartCustomFacilitiesAmount.lastAmount;
        },
    },
    methods: {
        // store setters
        setCartContext(context) {
            return this.$store.dispatch('defineCartContext', { data: context });
        },
        setCart(cart) {
            return this.$store.dispatch('defineCart', {
                data: cart,
                corpid: this.$store.state.corp.id,
            });
        },
        setCartId(id) {
            return this.$store.dispatch('defineCartId', id);
        },
        setCartPaymentMethod(method) {
            return this.$store.dispatch('defineCartPaymentMethod', { data: method });
        },
        setCartPaymentFacility(facility) {
            return this.$store.dispatch('defineCartPaymentFacility', { data: facility });
        },
        setCartPeriodStart(date) {
            return this.$store.dispatch('defineCartPeriodStart', { data: date });
        },
        setCartPeriodStop(date) {
            return this.$store.dispatch('defineCartPeriodStop', { data: date });
        },
        setCartExpiration(date) {
            return this.$store.dispatch('defineCartExpiration', { data: date });
        },
        setCartEarlyRenewal(isEarly) {
            return this.$store.commit('setCartEarlyRenewal', { data: isEarly });
        },
        setCartEarlyRenewalDiscount(earlyRenewalDiscount) {
            return this.$store.commit('setCartEarlyRenewalDiscount', {
                data: earlyRenewalDiscount,
            });
        },
        setCartContactAdded(contactAdded) {
            return this.$store.dispatch('defineCartContactAdded', { data: contactAdded });
        },
        setCartContactMailAddress(contactMailAddress) {
            return this.$store.dispatch('defineCartContactMailAddress', {
                data: contactMailAddress,
            });
        },
        setCartContactName(contactName) {
            return this.$store.dispatch('defineCartContactName', { data: contactName });
        },
        setCartContactPhone(contactPhone) {
            return this.$store.dispatch('defineCartContactPhone', { data: contactPhone });
        },
        setCartItems(items) {
            return this.$store.dispatch('defineCartItems', { data: items });
        },
        // store setters for saved
        setSavedCartTotal(total) {
            return this.$store.dispatch('defineSavedCartTotal', total);
        },
        setSavedCartStatus(status) {
            return this.$store.dispatch('defineSavedCartStatus', status);
        },
        setSavedCart(cart) {
            return this.$store.dispatch('defineCart', {
                context: 'saved',
                data: cart,
                corpid: this.$store.state.corp.id,
            });
        },
        setSavedCartItems(items) {
            return Promise.all([
                this.$store.dispatch('defineCartItems', {
                    context: 'saved',
                    data: this.deepCopy(items),
                }),
                this.setCartItems(this.deepCopy(items)),
            ]);
        },
        setSavedCartPaymentMethod(method) {
            return this.$store.dispatch('defineCartPaymentMethod', {
                context: 'saved',
                data: method,
            });
        },
        setSavedCartPaymentFacility(facility) {
            return this.$store.dispatch('defineCartPaymentFacility', {
                context: 'saved',
                data: facility,
            });
        },
        setSavedCartPeriodStart(date) {
            return this.$store.dispatch('defineCartPeriodStart', { context: 'saved', data: date });
        },
        setSavedCartExpiration(date) {
            return this.$store.dispatch('defineCartExpiration', { context: 'saved', data: date });
        },
        setSavedCartPeriodStop(date) {
            return this.$store.dispatch('defineCartPeriodStop', { context: 'saved', data: date });
        },
        // store setter for paymentIntent
        setCartPaymentIntent(paymentIntent) {
            paymentIntent.amount /= 100;
            return this.$store.dispatch('definePaymentIntent', paymentIntent);
        },
        setCartPaymentIntentTotal(total) {
            return this.$store.dispatch('definePaymentIntentTotal', total);
        },

        addCartItem(product_id, quantity, customPricing, quantityFree) {
            if (product_id === undefined) return;
            // build new item
            const newItem = {
                product_id: product_id,
                quantity: quantity || 1,
                customPricing: undefined !== customPricing ? customPricing : null,
                quantityFree: null !== quantityFree ? quantityFree : 0,
            };

            const items = [...this.cartItems];
            // either add or update item in cart
            if (this.getCartItem(product_id)) {
                items[_.findIndex(items, this.getCartItem(product_id))] = newItem;
            } else {
                items.push(newItem);
            }
            // persist
            return this.setCartItems(items);
        },
        removeCartItem(product_id) {
            // control if already in cart
            if (!this.getCartItem(product_id)) return;
            // remove from cart
            return this.setCartItems(_.without(this.cartItems, this.getCartItem(product_id)));
        },
        updateCartItemProperty(product_id, property, value) {
            if (!this.getCartItem(product_id)) return;
            const item = this.getCartItem(product_id);
            item[property] = value;
            return this.addCartItem(
                item.product_id,
                item.quantity,
                item.customPricing,
                item.quantityFree,
            );
        },
        updateCartItemQuantity(product_id, quantity) {
            return this.updateCartItemProperty(product_id, 'quantity', quantity);
        },
        updateCartItemQuantityOffered(product_id, quantityFree) {
            return this.updateCartItemProperty(product_id, 'quantityFree', quantityFree);
        },
        updateCartItemCustomPricing(product_id, customPricing) {
            return this.updateCartItemProperty(product_id, 'customPricing', customPricing);
        },
        /**
         * Update Cart CRM Users licences with custom pricing
         * @param {String} product_id
         * @param {Array} customPricing
         */
        updateUsersLicencesCustomPricing(product_id, customPricing) {
            return this.updateCartItemProperty(product_id, 'customPricing', customPricing);
        },
        getCartItem(product_id) {
            return this.cartItems.find((item) => item.product_id === product_id);
        },
        getCartGroupItem(product_group) {
            return this.cartItems.find((item) => item.product.groups.includes(product_group));
        },
        getCartItemSaved(product_id) {
            return this.savedCartItems.find((item) => item.product_id === product_id);
        },
        getCartGroupItemSaved(product_group) {
            return this.savedCartItems.find((item) => item.product.groups.includes(product_group));
        },
        resetCartItemsCustomPricing() {
            const items = this.cartItems.map((item) => {
                item.customPricing = null;
                return item;
            });
            return this.setCartItems(items);
        },
        isCartContext(context) {
            return this.cartContext === context;
        },
        confirmCartDeletion(onValidate, onCancel) {
            this.$confirm(
                this.$l10n.__('Souhaitez-vous vraiment supprimer ce panier ?'),
                this.$l10n.__('Suppression du panier'),
                {
                    cancelButtonText: this.$l10n.__('Annuler'),
                    confirmButtonText: this.$l10n.__('Confirmer la suppression'),
                    confirmButtonClass: 'btn btn-primary',
                    type: 'warning',
                },
            )
                .then(() => {
                    onValidate();
                })
                .catch(() => {
                    if (typeof onCancel === 'function') onCancel();
                });
        },
        getCartStatusData(status) {
            const data = {
                draft: {
                    label: this.$l10n.__('brouillon'),
                    css: 'default',
                },
                estimate: {
                    label: this.$l10n.__('envoyé'),
                    css: 'warning',
                },
                validating: {
                    label: this.$l10n.__('en cours de validation'),
                    css: 'warning',
                },
                validated: {
                    label: this.$l10n.__('validé'),
                    css: 'info',
                },
                paid: {
                    label: this.$l10n.__('payé'),
                    css: 'success',
                },
                canceled: {
                    label: this.$l10n.__('annulé'),
                    css: 'danger',
                },
            };
            return data[status];
        },

        setCartIsExpired(id) {
            return this.$store.dispatch('defineCartIsExpired', id);
        },
        setCartIsCancelable(id) {
            return this.$store.dispatch('defineCartIsCancelable', id);
        },
    },
};
